import { motion } from "framer-motion";
import { FileText, Video, Microscope, ClipboardCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Icon3D } from "./Icon3D";

const steps = [
  {
    icon: FileText,
    title: "Leitura da DS",
    desc: "Análise das informações prestadas e identificação de sinais de atenção.",
    variant: "deepBlue",
  },
  {
    icon: Video,
    title: "Entrevista gravada",
    desc: "Condução por enfermeiros avaliadores via videoatendimento.",
    variant: "vividBlue",
  },
  {
    icon: Microscope,
    title: "Apuração clínica",
    desc: "Mapeamento de morbidades, CID e indicação de CPT quando aplicável.",
    variant: "aqua",
  },
  {
    icon: ClipboardCheck,
    title: "Parecer técnico",
    desc: "Recomendações objetivas para decisão da operadora.",
    variant: "deepBlue",
  },
];

export const Methodology = () => {
  return (
    <section
      id="metodologia"
      data-testid="methodology-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Metodologia"
          title="Entrevista qualificada com"
          highlight="padrão técnico"
          subtitle="Um fluxo estruturado para rastrear risco assistencial e embasar decisões com mais clareza."
          testid="methodology-heading"
        />

        <div className="mt-16 relative">
          {/* connecting line desktop */}
          <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-[#3532B3] via-[#3787F5] to-[#12DDB5] opacity-30" />

          <div className="grid md:grid-cols-4 gap-8 relative">
            {steps.map((s, idx) => (
              <motion.div
                key={s.title}
                data-testid={`methodology-step-${idx}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.55,
                  ease: [0.16, 1, 0.3, 1],
                  delay: idx * 0.1,
                }}
                className="relative flex flex-col items-center text-center"
              >
                <div className="relative">
                  <Icon3D icon={s.icon} variant={s.variant} size="xl" />
                  <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-[#12DDB5] to-[#73F2B3] text-[#0b5a4a] text-sm font-extrabold flex items-center justify-center shadow-[0_6px_14px_rgba(18,221,181,0.45)] border-2 border-white">
                    {idx + 1}
                  </span>
                </div>
                <h3 className="mt-6 text-lg font-bold text-[#1F2937]">
                  {s.title}
                </h3>
                <p className="mt-2 text-[#64748B] text-[15px] leading-relaxed max-w-[260px]">
                  {s.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
